/**
 * Determines group type.
 * @param {string} groupUA groupUA id
 * @param {object} groupData {districts, schools, educators, classes}
 * @returns {string|null} 'School District', 'School', 'Teacher', 'Class', or null
 */
export default function getGroupType(
  groupUA,
  { districts, schools, educators, classes }
) {
  if (districts && districts[groupUA]) {
    return "School District"
  } else if (schools && schools[groupUA]) {
    return "School"
  } else if (educators && educators[groupUA]) {
    return "Teacher"
  } else if (classes && classes[groupUA]) {
    return "Class"
  } else {
    return null
  }
}
